// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1EbmHfWxW5","item":"_2VOByRb792","label":"TRJVw3-TJW","detail":"_14c_5IyFgc"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/DetailList/DetailList.module.less
// module id = 1000
// module chunks = 3